import "./jiffymade-landing-header.scss";

const $getPageAnchors = () => document.querySelectorAll(".js-jiffymade-landing-anchor");

export const initNavigation = () => {
  $getPageAnchors().forEach(anchor => {
    anchor.addEventListener("click", e => {
      e.preventDefault();

      document.querySelector(e.target.getAttribute("href")).scrollIntoView({
        behavior: "smooth"
      });
    });
  });
};

export default initNavigation;
